'use client';

import { addressFieldsPrefix } from '@verifime/utils';
import { TFormFieldsAndRulesV3 } from '../../Form';
import useAddEntity from './useAddEntityV2';
import { AddressFieldsAndRulesName, individualFormFieldsAndRules } from './utils';

type TUseAddEntity = Parameters<typeof useAddEntity>[0];

/**
 * Individual entity V2 wrapper. Required `AddressView` is forwarded from
 * `props` through to `useAddEntityV2`; callers in customer-portal typically
 * supply `AddressAutocompleteView` from `@verifime/views`.
 */
export default function useAddIndividualEntityV2({
  extraFormFieldsAndRules = {},
  ...props
}: {
  extraFormFieldsAndRules?: TFormFieldsAndRulesV3;
} & Omit<TUseAddEntity, 'initialFormFieldsAndRules' | 'initialAddresses'>) {
  return useAddEntity({
    initialFormFieldsAndRules: {
      ...individualFormFieldsAndRules,
      ...extraFormFieldsAndRules,
    },
    initialAddresses: [
      {
        renderType: 'AddressWithCountrySelect',
        fieldsAndRulesName: AddressFieldsAndRulesName.addressFieldsAndRules,
        label: '',
        inputLabel: 'Residential Address',
        inputPlaceholder: 'Address',
        fieldsPrefix: addressFieldsPrefix,
      },
    ],
    ...props,
  });
}
